"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const resolveItemSelection = (_ref, selectedId) => {
  let {
    id,
    label,
    items
  } = _ref;
  const itemId = id ?? label;

  // Treat item as selected if it or any nested child matches the selected id
  const selected = Boolean(selectedId === itemId || items?.some(item => resolveItemSelection(item, selectedId).selected));
  return {
    itemId,
    selected
  };
};
var _default = exports.default = resolveItemSelection;